import axios from "axios";
import { url } from '../utils/config';
import Table from "../reusable_components/Table";
import { toast } from "react-toastify";
import { btnGreen, btnRed, title } from "../utils/style";
import moment from "moment";


function LeaveRequest() {
    
    async function approveLeaveRequest(id) {
        try {
            const reqUrl = url + `/approve_leave/${id}`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const res = await axios.get(reqUrl, { headers });
            toast.success(res.data.message, { autoClose: 3000 })
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    async function rejectLeaveRequest(id) {
        try {
            const reqUrl = url + `/reject_leave/${id}`;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const res = await axios.get(reqUrl, { headers });
            toast.success(res.data.message, { autoClose: 3000 })
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    const options = [
        {
            header: 'REQUESTED BY',
            render: (data) => {return data.technician.firstName},
            filterKey: 'name'
        },
        {
            header: 'DATE',
            key: 'date',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'REASON',
            key: 'reason',
        },
        {
            header: 'LEAVE BALANCE',
            render: (data) => {return data.technician.leaveBalance}
        },
        {
            header: 'ACTION',
            render: (data) => {
                return (
                    <>
                        <span 
                            className={btnGreen}
                            onClick={() => approveLeaveRequest(data.id)}
                        >
                            Approve
                        </span>
                        <span 
                            className={btnRed}
                            onClick={() => rejectLeaveRequest(data.id)}
                        >
                            Reject
                        </span>
                    </>
                )            
            },
        }
    ]

    const excludeFilter = ['LEAVE BALANCE', 'ACTION']

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Leave Requests</div>

            <Table 
                options={options} 
                url={url + '/leave_requests'} 
                pagination 
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default LeaveRequest;